import { images } from "../../../Assets/assetsHelper";
import AddCourseForm from "../../../Components/Organisms/Forms/AddCourseForm/AddCourseForm";
import { useNavigate } from "react-router";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

function AddCourse({
  Edit = false,
  course = null,
  loading = false,
  url,
  attributesEdit = false,
}) {
  const navigate = useNavigate();

  return (
    <div className="mainContainer">
      <Card className="modernFormCard">
        <CardContent className="modernFormCardContent">
          <div className="formHeader">
            <div className="titleIcon">
              <MenuBookIcon />
            </div>
            <div className="titleContent">
              <h1>
                {Edit
                  ? attributesEdit
                    ? "Edit Program Attributes"
                    : "Edit Program Information"
                  : "Add New Program"}
              </h1>
            </div>
          </div>

          <div className="formDivider"></div>

          <Box className="modernFormWrapper">
            {loading && Edit ? (
              <div className="loadingBox">
                <CircularProgress />
              </div>
            ) : (
              <AddCourseForm
                Edit={Edit}
                course={course}
                url={url}
                attributesEdit={attributesEdit}
              />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Modern Footer Section */}
      <div className="modernFooterSection">
        <Typography variant="body2" className="footerText">
          {Edit
            ? "Make sure all information is accurate before saving changes."
            : "Please fill in all required fields to create the program profile."}
        </Typography>
      </div>
    </div>
  );
}

export default AddCourse;
